import {Component, forwardRef, Inject, Injector} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ClientService} from '../../services/client.service';
import {AlertService} from '../../services/alert.service';
import {SessionService} from '../../services/session.service';
import {TranslateService} from '@ngx-translate/core';
import {EmployeeTimesheetLine} from '../../model/EmployeeTimesheetLine';

import {Utils} from "../../model/Utils";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {ExplainMeal} from "./ExplainMeal";
import {EmployeeHoraire} from "../../model/EmployeHoraire";


@Component({
  templateUrl: './MealsTimesheetComponent.html'
})

export class MealsTimesheetComponent{

  line: EmployeeTimesheetLine;
  currentEmployeeHoraire: EmployeeHoraire;


  constructor (private injector: Injector,
               @Inject(forwardRef(() => NgbModal)) private modalService: NgbModal,
               @Inject(forwardRef(() => ClientService)) private clientService: ClientService,
               @Inject(forwardRef(() => DomSanitizer)) private domSanitizer: DomSanitizer,
               @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
               @Inject(forwardRef(() => SessionService)) private session: SessionService,
               @Inject(forwardRef(() => TranslateService)) private translate: TranslateService) {
    this.line = this.injector.get('line');
    this.currentEmployeeHoraire = this.line.retrieveCurrentEmployeeHoraire();
    this._validate();
  }

  private _validate() {
    this.line.validateMeal1(this.translate);
    this.line.validateMeal2(this.translate);
  }


  needToSpecifyHours(): boolean{
    let res = true;
    if (!Utils.isNullOrUndefined(this.currentEmployeeHoraire.tsType)){
      res = this.currentEmployeeHoraire.tsType.needsToSpecifyHours()
    }
    this.line.meal1Validation.applyStyle=res;
    this.line.meal2Validation.applyStyle=res;
    this.line.break1Validation.applyStyle=res;
    this.line.break2Validation.applyStyle=res;
    return res;
  }



  public explainMeal1():SafeHtml{
    // const displayMinute = new DisplayMinute();
//    console.log('Explaining Break1 ' + this.currentEmployeeHoraire.retrieveMinuteRemovedFromBreak1(this.line.normalBreakDuration));
    const explainMeal = new ExplainMeal(this.domSanitizer,this.translate);
    let scheduledMealDurationInMinutes = 0 ;
    if (!Utils.isNullOrUndefined(this.currentEmployeeHoraire.sdMeal1Start) && !Utils.isNullOrUndefined(this.currentEmployeeHoraire.sdMeal1End)){
      scheduledMealDurationInMinutes = Utils.diffDateInMinutes(this.currentEmployeeHoraire.sdMeal1Start,this.currentEmployeeHoraire.sdMeal1End);
    }
    // console.log('explainMeal1: ' + scheduledMealDurationInMinutes);
    return explainMeal.explainMeal(this.line.mealDurationType,this.line.normalMealDuration,scheduledMealDurationInMinutes,this.currentEmployeeHoraire.tsMeal1Paid,
      this.currentEmployeeHoraire.tsMeal1PunchAdj,this.currentEmployeeHoraire.tsMeal1Start,this.currentEmployeeHoraire.tsMeal1End);
  }


  public explainMeal2():SafeHtml{
    // const displayMinute = new DisplayMinute();
//    console.log('Explaining Break1 ' + this.currentEmployeeHoraire.retrieveMinuteRemovedFromBreak1(this.line.normalBreakDuration));
    const explainMeal = new ExplainMeal(this.domSanitizer,this.translate);
    let scheduledMealDurationInMinutes = 0 ;
    if (!Utils.isNullOrUndefined(this.currentEmployeeHoraire.sdMeal2Start) && !Utils.isNullOrUndefined(this.currentEmployeeHoraire.sdMeal2End)){
      scheduledMealDurationInMinutes = Utils.diffDateInMinutes(this.currentEmployeeHoraire.sdMeal2Start,this.currentEmployeeHoraire.sdMeal2End);
    }

    return explainMeal.explainMeal(this.line.mealDurationType,this.line.normalMealDuration,scheduledMealDurationInMinutes,this.currentEmployeeHoraire.tsMeal2Paid,
      this.currentEmployeeHoraire.tsMeal2PunchAdj,this.currentEmployeeHoraire.tsMeal2Start,this.currentEmployeeHoraire.tsMeal2End);
  }




  retrieveWhatToRemoveForMeal1(){
    const dates =  this.currentEmployeeHoraire.calculateDatesForMeal1(this.line.mealDurationType,this.line.normalMealDuration);
    // console.log('meal1: ' + JSON.stringify(dates,null,1));
    // console.log('startPunch: ' + dates.startPunch + ' endPunch: ' + dates.endPunch);

    return Utils.diffDateInMinutes(dates.startPunch,dates.endPunch);
  }

  retrieveWhatToRemoveForMeal2(){
    const dates = this.currentEmployeeHoraire.calculateDatesForMeal2(this.line.mealDurationType,this.line.normalMealDuration);
    // console.log('meal2: ' + JSON.stringify(dates,null,1));
    return Utils.diffDateInMinutes(dates.startPunch,dates.endPunch);
  }





  public hasMeal1ScheduledInfo(): boolean {
    if (!this.needToSpecifyHours()){
      return false;
    }
    if (!Utils.isNullOrUndefined(this.currentEmployeeHoraire.tsMeal1StartPunchDt) || !Utils.isNullOrUndefined(this.currentEmployeeHoraire.tsMeal1EndPunchDt)){
      return true;
    }
    if (!this.currentEmployeeHoraire.sdMeal1Start) {
      if (!this.currentEmployeeHoraire.sdMeal1End) {
          return false;
      }
    }
    return true;
  }

  public hasMeal1PunchInfo() {
    if (!this.needToSpecifyHours()){
      return false;
    }
    if (!this.currentEmployeeHoraire.tsMeal1StartPunchDt) {
      if (!this.currentEmployeeHoraire.tsMeal1EndPunchDt) {
        return false;
      }
    }
    return true;
  }



  public hasMeal1ApprovedTS() {
    if (!this.needToSpecifyHours()){
      console.log('No Need to specify Hours');
      return false;
    }
    if (Utils.diffDateInMinutes(this.currentEmployeeHoraire.tsMeal1Start,this.currentEmployeeHoraire.tsMeal1End)===0){
//      console.log('No Duration Meal1');
      return false;
    }
    // if (!this.currentEmployeeHoraire.tsMeal1Start) {
    //   if (!this.currentEmployeeHoraire.tsMeal1End) {
    //     return false;
    //   }
    // }
    return true;
  }

  public hasMeal1Info(): boolean {
    if (!this.needToSpecifyHours()){
      // console.log('NoNeedToSpecifyHours');
      return false;
    }
    if (!this.hasMeal1ScheduledInfo()) {
      // console.log('No Schedule');
      if (! this.hasMeal1PunchInfo()) {
        // console.log('No Punched');
        if (! this.hasMeal1ApprovedTS()) {
          // console.log('Meal1 not approoved');
          return false;
        }
      }
    }
    return true;
  }

  public hasMeal2ScheduledInfo() {
    if (!this.needToSpecifyHours()){
      return false;
    }
    if (!Utils.isNullOrUndefined(this.currentEmployeeHoraire.tsMeal2StartPunchDt) || !Utils.isNullOrUndefined(this.currentEmployeeHoraire.tsMeal2EndPunchDt)){
      return true;
    }
    if (!this.currentEmployeeHoraire.sdMeal2Start) {
      if (!this.currentEmployeeHoraire.sdMeal2End) {
        return false;
      }
    }
    return true;
  }

  public hasMeal2PunchInfo() {
    if (!this.needToSpecifyHours()){
      return false;
    }
    if (!this.currentEmployeeHoraire.tsMeal2StartPunchDt) {
      if (!this.currentEmployeeHoraire.tsMeal2EndPunchDt) {
        return false;
      }
    }
    return true;
  }



  public hasMeal2ApprovedTS() {
    if (!this.needToSpecifyHours()){
      return false;
    }
    if (Utils.diffDateInMinutes(this.currentEmployeeHoraire.tsMeal2Start,this.currentEmployeeHoraire.tsMeal2End)===0){
      return false;
    }
    return true;
  }
  public hasMeal2Info(): boolean {
    if (!this.needToSpecifyHours()){
      return false;
    }
    if (!this.hasMeal2ScheduledInfo()) {
      if (! this.hasMeal2PunchInfo()) {
        if (! this.hasMeal2ApprovedTS()) {
          return false;
        }
      }
    }
    return true;
  }


}


